var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowAndHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66699 2.66634C2.66699 1.93015 3.26414 1.33301 4.00033 1.33301H6.66699C7.40318 1.33301 8.00032 1.93015 8.00032 2.66634V13.333C8.00032 14.0692 7.40318 14.6663 6.66699 14.6663H4.00033C3.26414 14.6663 2.66699 14.0692 2.66699 13.333V2.66634ZM6.66699 2.66634H4.00033V13.333H6.66699V2.66634ZM8.66699 1.33301H12.0003C12.7365 1.33301 13.3337 1.93015 13.3337 2.66634V13.333C13.3337 14.0692 12.7365 14.6663 12.0003 14.6663H8.66699V1.33301ZM10.0003 2.66634V13.333H12.0003V2.66634H10.0003Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.33301 13.3333V2.66667C7.33301 2.29867 7.03434 2 6.66634 2H3.99967C3.63167 2 3.33301 2.29867 3.33301 2.66667V13.3333C3.33301 13.7013 3.63167 14 3.99967 14H6.66634C7.03434 14 7.33301 13.7013 7.33301 13.3333Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 5.33301H7.33301V6.66634H3.33301V5.33301ZM9.33301 5.33301H12.6663V6.66634H9.33301V5.33301ZM7.33301 10.6663H3.33301V9.33301H7.33301V10.6663ZM9.33301 9.33301H12.6663V10.6663H9.33301V9.33301Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowAndHide);
export default __webpack_public_path__ + "static/media/show-and-hide.a72f7800.svg";
export { ForwardRef as ReactComponent };